// extracted by mini-css-extract-plugin
export var imageWrapper = "WineFinder-module--imageWrapper--EktHO";
export var label = "WineFinder-module--label--JDJM+";
export var text = "WineFinder-module--text--NodD0";